export const serviceCategories = [
  {
    id: "wig-install-packages",
    name: "Wig Install Packages",
    services: [
      {
        name: "Basic Frontal install Package",
        duration: "3 hours",
        price: "$210.00",
        details:
          "- Wash and blow-dry included\n- Silk press or curls included. If you want curls, please add them on so I can be prepared.\n- Unit drop-off is required 1 day before your appointment.\n- NO AMAZON OR ALIEXPRESS WIGS. If the lace is too thick or too white, the appointment must be rescheduled.",
        addOns: [
          { id: "613-tone", name: "613 tone", price: 90 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "half-up-half-down", name: "Half up half down (+30 minutes)", price: 30 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "low-bun", name: "Low Bun (+60 minutes)", price: 60 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "Book this package",
      },
      {
        name: "Basic Closure wig install Package",
        duration: "1 hour 30 minutes",
        price: "$180.00",
        details:
          "- Wash and blow-dry included\n- Silk press or curls included. If you want curls, please add them on so I can be prepared.\n- No unit drop-off is required.\n- NO AMAZON OR ALIEXPRESS WIGS. If the lace is too thick or too white, the appointment must be rescheduled.\n- No low-quality lace. Thick, white, transparent lace is not accepted. Thin HD lace is best. Some transparent lace is acceptable, but not the typical Amazon lace.",
        addOns: [
          { id: "613-tone", name: "613 tone", price: 90 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "Book this package",
      },
      {
        name: "Basic Finger wave unit install Package",
        duration: "3 hours",
        price: "$225.00",
        details:
          "- The unit may be short and from Amazon, since it will be heavily cut for this look.",
        cta: "Book this package",
      },
      {
        name: "Deluxe Frontal Install",
        duration: "3 hours",
        price: "$110.00",
        details:
          "BOOK 5 DAYS IN ADVANCE\n- 13*4 HD lace wig from The Luxe Loft\n- 13*6 lace or 613 is available as an add-on\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included",
        addOns: [
          { id: "18-inch", name: "18\"", price: 350 },
          { id: "20-inch", name: "20\"", price: 380 },
          { id: "22-inch", name: "22\"", price: 410 },
          { id: "24-inch", name: "24\"", price: 440 },
          { id: "26-inch", name: "26\"", price: 470 },
          { id: "28-inch", name: "28\"", price: 490 },
          { id: "30-inch", name: "30\"", price: 510 },
          { id: "32-inch", name: "32\"", price: 535 },
          { id: "34-inch", name: "34\"", price: 560 },
          { id: "36-inch", name: "36\"", price: 570 },
          { id: "38-inch", name: "38\"", price: 600 },
          { id: "40-inch", name: "40\"", price: 610 },
          { id: "613", name: "613", price: 20 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "low-bun", name: "Low Bun (+60 minutes)", price: 60 },
          { id: "straight", name: "Straight", price: 0 },
          { id: "upgrade-13x6-hd-lace", name: "Upgrade to 13*6 HD lace", price: 85 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
          { id: "curls", name: "Curls (+30 minutes)", price: 0 },
        ],
        cta: "Book this package",
      },
    ],
  },
  {
    id: "sew-in-packages",
    name: "Sew-In Packages",
    services: [
      {
        name: "Basic Frontal Sew in Package",
        duration: "4 hours 30 minutes",
        price: "$300.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Silk press or curls. Please add curls so I can be prepared.\n- For the best outcome, no Amazon or beauty supply store bundles/lace.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "low-bun", name: "Low Bun (+60 minutes)", price: 60 },
          { id: "old-sew-in-take-down-wash", name: "Old sew in take down + wash (+1 hour)", price: 100 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "upgrade-to-13x6", name: "Upgrade to 13*6", price: 75 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic Closure Sew in Package",
        duration: "4 hours",
        price: "$275.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Silk press or curls. Please add curls so I can be prepared.\n- For the best outcome, no Amazon or beauty supply store bundles/lace.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "glueless", name: "Glueless", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "old-sew-in-take-down-wash", name: "Old sew in take down + wash (+1 hour)", price: 100 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic Traditional Sew in Package",
        duration: "4 hours",
        price: "$250.00",
        details:
          "Includes:\n- Wash and blow-dry included\n- Silk press or curls included. Please add curls so I can be prepared.\n- For the best outcome, no Amazon or beauty supply store bundles.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "2-part-versatile-sew-in", name: "2 part Versatile sew in (+45 minutes)", price: 30 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "old-sew-in-take-down-wash", name: "Old sew in take down + wash (+1 hour)", price: 100 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Frontal Sew In Package",
        duration: "3 hours 30 minutes",
        price: "$150.00",
        details:
          "Includes:\n- 13*4 frontal and virgin bundles from The Luxe Loft\n- Wash and blow-dry\nBook this service at least 5 business days before your desired appointment date to ensure hair is in stock.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "3x18-plus-13x4-18-frontal", name: "3 18\" + 13*4 HD 18\" Frontal", price: 415 },
          { id: "3x20-plus-13x4-18-frontal", name: "3 20\" + 13*4 HD 18\" Frontal", price: 430 },
          { id: "3x22-plus-13x4-18-frontal", name: "3 22\" + 13*4 HD 18\" Frontal", price: 450 },
          { id: "3x24-plus-13x4-20-frontal", name: "3 24\" + 13*4 HD 20\" Frontal", price: 480 },
          { id: "3x26-plus-13x4-20-frontal", name: "3 26\" + 13*4 HD 20\" Frontal", price: 510 },
          { id: "4x28-plus-13x4-20-frontal", name: "4 28\" + 13*4 HD 20\" Frontal", price: 610 },
          { id: "4x30-plus-13x4-20-frontal", name: "4 30\" + 13*4 HD 20\" Frontal (+1 hour 5 minutes)", price: 640 },
          { id: "4x32-plus-13x4-20-frontal", name: "4 32\" + 13*4 HD 20\" Frontal", price: 665 },
          { id: "4x34-plus-13x4-20-frontal", name: "4 34\" + 13*4 HD 20\" Frontal", price: 700 },
          { id: "4x36-plus-13x4-20-frontal", name: "4 36\" + 13*4 HD 20\" Frontal", price: 750 },
          { id: "4x38-plus-13x4-20-frontal", name: "4 38\" + 13*4 HD 20\" Frontal", price: 800 },
          { id: "4x40-plus-13x4-20-frontal", name: "4 40\" + 13*4 HD 20\" Frontal", price: 850 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "low-bun", name: "Low Bun (+60 minutes)", price: 60 },
          { id: "loose-deep-wave", name: "Loose deep wave", price: 0 },
          { id: "straight", name: "Straight", price: 0 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Sew In Package",
        duration: "3 hours 30 minutes",
        price: "$115.00",
        details:
          "Includes:\n- 3 virgin bundles from The Luxe Loft for 18\"-24\". Lengths 26\" and up include 4 bundles.\n- Wash and blow-dry\nBook this service at least 5 business days before your desired appointment date to ensure hair is in stock.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "18-18-18", name: "18\"-18\"-18\"", price: 300 },
          { id: "20-20-20", name: "20-20-20", price: 320 },
          { id: "2-part-versatile-sew-in", name: "2 part Versatile sew in (+45 minutes)", price: 30 },
          { id: "22-22-22", name: "22\"-22\"-22\"", price: 345 },
          { id: "24-24-24", name: "24\"-24\"-24\"", price: 370 },
          { id: "26-26-26-26", name: "26\"-26\"-26\"-26\"", price: 445 },
          { id: "28-28-28-28", name: "28\"-28\"-28\"-28\"", price: 515 },
          { id: "30-30-30-30", name: "30\"-30\"-30\"-30\"", price: 530 },
          { id: "32-32-32-32", name: "32\"-32\"-32\"-32\"", price: 550 },
          { id: "34-34-34-34", name: "34\"-34\"-34\"-34\"", price: 580 },
          { id: "36-36-36-36", name: "36\"-36\"-36\"-36\"", price: 630 },
          { id: "38-38-38-38", name: "38\"-38\"-38\"-38\"", price: 685 },
          { id: "40-40-40-40", name: "40\"-40\"-40\"-40\"", price: 730 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "loose-deep-wave", name: "Loose deep wave", price: 0 },
          { id: "straight", name: "Straight", price: 0 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Closure Sew In Package",
        duration: "3 hours",
        price: "$130.00",
        details:
          "Includes:\n- 3 virgin bundles and a closure from The Luxe Loft for 18\"-24\". Lengths 26\" and up include 4 bundles.\n- Wash and blow-dry\nBook this service at least 5 business days before your appointment date to ensure hair is in stock.\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "2x6-closure", name: "2*6 closure", price: -15 },
          { id: "3x18-plus-5x5-hd-18-closure", name: "3 18\" + 5*5 HD 18\" closure", price: 385 },
          { id: "3x20-plus-5x5-hd-18-closure", name: "3 20\" + 5*5 HD 18\" closure", price: 400 },
          { id: "3x22-plus-5x5-hd-18-closure", name: "3 22\" + 5*5 HD 18\" closure", price: 420 },
          { id: "3x24-plus-5x5-hd-18-closure", name: "3 24\" + 5*5 HD 18\" closure", price: 445 },
          { id: "4x26-plus-5x5-hd-20-closure", name: "4 26\" + 5*5 HD 20\" closure", price: 520 },
          { id: "4x28-plus-5x5-hd-20-closure", name: "4 28\" + 5*5 HD 20\" closure", price: 575 },
          { id: "4x30-plus-5x5-hd-20-closure", name: "4 30\" + 5*5 HD 20\" closure", price: 600 },
          { id: "4x32-plus-5x5-hd-20-closure", name: "4 32\" + 5*5 HD 20\" closure", price: 620 },
          { id: "4x34-plus-5x5-hd-20-closure", name: "4 34\" + 5*5 HD 20\" closure", price: 650 },
          { id: "4x36-plus-5x5-hd-20-closure", name: "4 36\" + 5*5 HD 20\" closure", price: 700 },
          { id: "4x38-plus-5x5-hd-20-closure", name: "4 38\" + 5*5 HD 20\" closure", price: 750 },
          { id: "4x40-plus-5x5-hd-20-closure", name: "4 40\" + 5*5 HD 20\" closure", price: 800 },
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "glueless", name: "Glueless", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "loose-deep-wave", name: "Loose deep wave", price: 0 },
          { id: "straight", name: "Straight", price: 0 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
    ],
  },
  {
    id: "quickweaves-packages",
    name: "Quickweaves Packages",
    services: [
      {
        name: "Basic Quickweave Package",
        duration: "2 hours 40 minutes",
        price: "$180.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Silk press or curls",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+30 minutes, included)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "old-quickweave-take-down-wash", name: "Old quickweave take down + wash (+45 minutes)", price: 70 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic Frontal Quickweave Package",
        duration: "3 hours 20 minutes",
        price: "$210.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Silk press or curls",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "old-quickweave-take-down-wash", name: "Old quickweave take down + wash (+45 minutes)", price: 70 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic Closure Quickweave Package",
        duration: "3 hours",
        price: "$195.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Silk press or basic curls",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "old-quickweave-take-down-wash", name: "Old quickweave take down + wash (+45 minutes)", price: 70 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "half up half down quick weave",
        duration: "3 hours",
        price: "$130.00",
        details: "Half-up, half-down quickweave style.",
        addOns: [
          { id: "butterfly-or-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Quickweave Package",
        duration: "2 hours 30 minutes",
        price: "$80.00",
        details:
          "BOOK AT LEAST 5 DAYS IN ADVANCE\nIncludes:\n- 3 bundles from The Luxe Loft\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included",
        addOns: [
          { id: "18-18-18", name: "18\"-18\"-18\"", price: 300 },
          { id: "20-20-20", name: "20-20-20", price: 320 },
          { id: "22-22-22", name: "22\"-22\"-22\"", price: 345 },
          { id: "24-24-24", name: "24\"-24\"-24\"", price: 370 },
          { id: "26-26-26-26", name: "26\"-26\"-26\"-26\"", price: 445 },
          { id: "28-28-28-28", name: "28\"-28\"-28\"-28\"", price: 515 },
          { id: "30-30-30-30", name: "30\"-30\"-30\"-30\"", price: 530 },
          { id: "32-32-32-32", name: "32\"-32\"-32\"-32\"", price: 550 },
          { id: "34-34-34-34", name: "34\"-34\"-34\"-34\"", price: 580 },
          { id: "36-36-36-36", name: "36\"-36\"-36\"-36\"", price: 630 },
          { id: "38-38-38-38", name: "38\"-38\"-38\"-38\"", price: 685 },
          { id: "40-40-40-40", name: "40\"-40\"-40\"-40\"", price: 730 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "curls", name: "Curls (+30 minutes, included)", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Closure Quickweave Package",
        duration: "3 hours",
        price: "$110.00",
        details:
          "BOOK 5 DAYS IN ADVANCE\nIncludes:\n- 3 bundles and a 5*5 closure from The Luxe Loft\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included",
        addOns: [
          { id: "3x18-plus-5x5-hd-18-closure", name: "3 18\" + 5*5 HD 18\" closure", price: 385 },
          { id: "3x20-plus-5x5-hd-18-closure", name: "3 20\" + 5*5 HD 18\" closure", price: 400 },
          { id: "3x22-plus-5x5-hd-18-closure", name: "3 22\" + 5*5 HD 18\" closure", price: 420 },
          { id: "3x24-plus-5x5-hd-18-closure", name: "3 24\" + 5*5 HD 18\" closure", price: 445 },
          { id: "4x26-plus-5x5-hd-20-closure", name: "4 26\" + 5*5 HD 20\" closure", price: 520 },
          { id: "4x28-plus-5x5-hd-20-closure", name: "4 28\" + 5*5 HD 20\" closure", price: 575 },
          { id: "4x30-plus-5x5-hd-20-closure", name: "4 30\" + 5*5 HD 20\" closure", price: 600 },
          { id: "4x32-plus-5x5-hd-20-closure", name: "4 32\" + 5*5 HD 20\" closure", price: 620 },
          { id: "4x34-plus-5x5-hd-20-closure", name: "4 34\" + 5*5 HD 20\" closure", price: 650 },
          { id: "4x36-plus-5x5-hd-20-closure", name: "4 36\" + 5*5 HD 20\" closure", price: 700 },
          { id: "4x38-plus-5x5-hd-20-closure", name: "4 38\" + 5*5 HD 20\" closure", price: 750 },
          { id: "4x40-plus-5x5-hd-20-closure", name: "4 40\" + 5*5 HD 20\" closure", price: 800 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "curls", name: "Curls (+30 minutes, included)", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Frontal Quickweave Package",
        duration: "3 hours 30 minutes",
        price: "$130.00",
        details:
          "BOOK 5 DAYS IN ADVANCE\n- 3 bundles and a 13*4 frontal from The Luxe Loft\n- Add-on option: 13*6 frontal\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included",
        addOns: [
          { id: "3x18-plus-13x4-hd-18-frontal", name: "3 18\" + 13*4 HD 18\" Frontal", price: 415 },
          { id: "4x28-plus-13x4-hd-20-frontal", name: "4 28\" + 13*4 HD 20\" Frontal", price: 610 },
          { id: "4x30-plus-13x4-hd-20-frontal", name: "4 30\" + 13*4 HD 20\" Frontal (+1 hour 5 minutes)", price: 640 },
          { id: "4x32-plus-13x4-hd-20-frontal", name: "4 32\" + 13*4 HD 20\" Frontal", price: 665 },
          { id: "4x34-plus-13x4-hd-20-frontal", name: "4 34\" + 13*4 HD 20\" Frontal", price: 700 },
          { id: "4x36-plus-13x4-hd-20-frontal", name: "4 36\" + 13*4 HD 20\" Frontal", price: 750 },
          { id: "4x38-plus-13x4-hd-20-frontal", name: "4 38\" + 13*4 HD 20\" Frontal", price: 800 },
          { id: "4x40-plus-13x4-hd-20-frontal", name: "4 40\" + 13*4 HD 20\" Frontal", price: 850 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          { id: "custom-highlights-26-36", name: "Custom highlights 26\"-36\"", price: 145 },
          { id: "upgrade-13x6-hd-lace", name: "Upgrade to 13*6 HD lace", price: 85 },
          { id: "curls", name: "Curls (+30 minutes, included)", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
    ],
  },
  {
    id: "ponytails",
    name: "Ponytails",
    services: [
      {
        name: "Basic Frontal ponytail Package",
        duration: "3 hours",
        price: "$260.00",
        details: "Basic frontal ponytail package.",
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Braided ponytail",
        duration: "1 hour 30 minutes",
        price: "$100.00",
        details:
          "Please arrive with hair freshly washed and blow-dried. This service includes:\n- Silk press\n- Styling\nBraiding hair is not included.",
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic High/low ponytail",
        duration: "2 hours 30 minutes",
        price: "$120.00",
        details:
          "Book this style if you want a high or low ponytail using bundles you provide.\nPlease arrive with hair freshly washed and blow-dried. This service includes:\n- Silk press\n- Styling\nHair is not included.",
        cta: "BOOK THE LOOK!",
      },
    ],
  },
  {
    id: "maintenance-reinstalls-takedowns",
    name: "Maintenance's, Reinstalls, and TakeDowns",
    services: [
      {
        name: "Frontal wig maintenance",
        duration: "1 hour",
        price: "$110.00",
        details:
          "- For minimal lifting only\n- Please remove your unit and book a reinstall if your unit is lifting severely\n- Lace will be cleaned and re-glued where needed\n- Restyling included; curls MUST be added",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "butterfly-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "half-up-half-down", name: "Half up half down (+30 minutes)", price: 30 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Reinstall",
        duration: "2 hours 30 minutes",
        price: "$170.00",
        details:
          "- Only book this if your unit was originally installed by ME\n- Must arrive with braids still in, and the wig fully cleaned with lace free of glue\n- If you need a braid-down and wig wash, you must book under a regular install\n- I do install over other stylists' work; however, it is considered a regular install and must be booked as a regular install",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "butterfly-fishtail-braid", name: "Butterfly or fishtail braid (+10 minutes)", price: 10 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "curls", name: "Curls (+35 minutes)", price: 0 },
          { id: "half-up-half-down", name: "Half up half down (+30 minutes)", price: 30 },
          { id: "up-do", name: "Up-do (+40 minutes)", price: 50 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Closure sew in maintenance",
        duration: "1 hour 30 minutes",
        price: "$120.00",
        details:
          "Closure will be removed and washed. Natural hair and bundles will be washed and restyled.",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
          { id: "curls", name: "Curls (+30 minutes)", price: 0 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Sew in maintenance",
        duration: "1 hour",
        price: "$100.00",
        details:
          "Natural hair and bundles will be washed and restyled.",
        addOns: [
          { id: "bang", name: "Bang", price: 15 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "bob-cut", name: "Bob cut (+15 minutes)", price: 15 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Quickweave take down",
        duration: "45 minutes",
        price: "$70.00",
        details:
          "Quickweave will be taken down and your natural hair will be washed. If you would like another quickweave done, please add it on.",
        addOns: [
          { id: "new-quickweave", name: "New quickweave (+1 hour 30 minutes)", price: 150 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Sew in take down",
        duration: "1 hour",
        price: "$100.00",
        details:
          "Traditional sew-in or closure sew-in will be taken down and hair will be washed. Please add on a new sew-in if desired.",
        addOns: [
          { id: "new-sew-in", name: "New sew in (+2 hours 40 minutes)", price: 175 },
          { id: "new-closure-sew-in", name: "New closure sew in (+2 hours 40 minutes)", price: 175 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Frontal sew in maintenance",
        duration: "30 minutes",
        price: "$130.00",
        details:
          "Frontal will be removed, hair and bundles will be washed, and the frontal will be reapplied. Hair will then be restyled.",
        addOns: [
          { id: "silk-scarf", name: "Silk scarf", price: 7 },
          { id: "wand-curls", name: "Wand curls (+30 minutes)", price: 30 },
          { id: "curls", name: "Curls (+30 minutes, included)", price: 0 },
          { id: "heavy-layers", name: "Heavy layers (+10 minutes)", price: 15 },
          { id: "crimps", name: "Crimps (+40 minutes)", price: 30 },
        ],
        cta: "BOOK THE LOOK!",
      },
    ],
  },
  {
    id: "flipovers-package",
    name: "Flipovers Package",
    services: [
      {
        name: "Basic Flipover Quickweave Package",
        duration: "2 hours 40 minutes",
        price: "$180.00",
        details:
          "- Comes with a wash and blow-dry",
        addOns: [
          { id: "curls", name: "Curls", price: 0 },
          { id: "custom-highlights-18-24", name: "Custom highlights 18\"-24\"", price: 115 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Flipover Sew in Package",
        duration: "3 hours 30 minutes",
        price: "$115.00",
        details:
          "BOOK AT LEAST 5 DAYS IN ADVANCE\nIncludes:\n- 3 bundles from The Luxe Loft (select curl type)\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "18-18-18", name: "18\"-18\"-18\"", price: 300 },
          { id: "20-20-20", name: "20-20-20", price: 320 },
          { id: "22-22-22", name: "22\"-22\"-22\"", price: 345 },
          { id: "24-24-24", name: "24\"-24\"-24\"", price: 370 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "loose-deep-wave", name: "Loose deep wave", price: 0 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Basic Flipover Sew In Package",
        duration: "4 hours",
        price: "$250.00",
        details:
          "Includes:\n- Wash and blow-dry\n- Sew-ins cannot be booked after 3:00 PM.",
        addOns: [
          { id: "curls", name: "Curls", price: 0 },
        ],
        cta: "BOOK THE LOOK!",
      },
      {
        name: "Deluxe Flipover Quickweave Package",
        duration: "2 hours 30 minutes",
        price: "$80.00",
        details:
          "BOOK AT LEAST 5 DAYS IN ADVANCE\nIncludes:\n- 3 bundles from The Luxe Loft (select curl type)\n- Please select your desired length in the add-on section\n- Wash and blow-dry\n- Silk press or curls included",
        addOns: [
          { id: "18-18-18", name: "18\"-18\"-18\"", price: 300 },
          { id: "20-20-20", name: "20-20-20", price: 320 },
          { id: "22-22-22", name: "22\"-22\"-22\"", price: 345 },
          { id: "24-24-24", name: "24\"-24\"-24\"", price: 370 },
          { id: "body-wave", name: "Body wave", price: 0 },
          {
            id: "color",
            name: "Color (text # after with desired look)",
            price: 90,
            requiresText: true,
            textLabel: "Desired color/look reference #",
            textPlaceholder: "Type the desired color/look #",
          },
          { id: "deepwave", name: "Deepwave", price: 0 },
          { id: "loose-deep-wave", name: "Loose deep wave", price: 0 },
          { id: "curls", name: "Curls", price: 0 },
        ],
        cta: "",
      },
    ],
  },
];

const slugify = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const bookableServices = serviceCategories.flatMap((category) =>
  category.services.map((service) => ({
    ...service,
    id: `${category.id}-${slugify(service.name)}`,
    service_id: `${category.id}-${slugify(service.name)}`,
    categoryId: category.id,
    categoryName: category.name,
    description: service.details || "",
  }))
);

export const findBookableServiceById = (serviceId) =>
  bookableServices.find((service) => service.id === serviceId || service.service_id === serviceId);
